
export const initialState = {
  isLoading: false,
  entitlementContractHistoryData: [],
  isEcontractHistoryResults: false,
  eContractHistoryTotalCount: 0,
  updateContractHistoryData: 
  {
    "message": "",
    "updated": false
  },
  updateContractHistoryLoading: false,
};
